import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { selectCityTimeZone, selectLocationTimeZone } from '../selector/locationsSelector';

/**
 * #3219: the IANA zone of location `locationId` — what a screen holding a
 * location id passes to the `stationTime` helpers. While the location is
 * unknown it is `fallbackZone` (e.g. the edited booking's `locationTimeZone`),
 * else the station default. See `selectLocationTimeZone`.
 */
export const useLocationTimeZone = (
    locationId: string | null | undefined,
    fallbackZone?: string | null,
): string => useSelector((state: RootState) => selectLocationTimeZone(state, locationId, fallbackZone));

/**
 * #3219: the zone shared by the locations of `city` — the clock a search by
 * city runs on before any one location is picked. See `selectCityTimeZone`.
 */
export const useCityTimeZone = (city: string | null | undefined): string =>
    useSelector((state: RootState) => selectCityTimeZone(state, city));
